<div class="maintenance-timer" [nbSpinner]="isLoading()" [class.expired]="expired() && !isEditing()">
  @if (isEditing()) {
    <div class="timer-container" [formGroup]="form()">
      <div class="card-body">
        @if (lockedConfig()) {
          <wr-banner class="config-banner"
                     [icon]="{ icon: 'info-outline', pack: 'eva' }"
                     status="info"
                     message="Startdatum, Dauer und Fristen werden aus der Konfiguration des TGA-Bauplans übernommen.">
          </wr-banner>
        } @else if (hasLockedConfigs()) {
          <wr-banner class="config-banner"
                     [icon]="{ icon: 'info-outline', pack: 'eva' }"
                     status="basic"
                     message="Für diese Art ist am TGA-Bauplan nichts konfiguriert - Startdatum, Dauer und Fristen sind frei wählbar.">
          </wr-banner>
        }
        <div class="form-grid">
          <hau-form-field label="Art">
            <nb-select formControlName="type" fullWidth optionsListClass="maintenance-timer-type-options"
                       (selectedChange)="onTypeChange($event)">
              <nb-option [value]="TypeEnum.Maintenance">{{ TypeEnum.Maintenance | maintenanceTimerType }}</nb-option>
              <nb-option [value]="TypeEnum.Inspection">{{ TypeEnum.Inspection | maintenanceTimerType }}</nb-option>
              <nb-option [value]="TypeEnum.SelfInspection">{{ TypeEnum.SelfInspection | maintenanceTimerType }}</nb-option>
              @if (canEditWarranty()) {
                <nb-option [value]="TypeEnum.Warranty">{{ TypeEnum.Warranty | maintenanceTimerType }}</nb-option>
              }
            </nb-select>
          </hau-form-field>

          <hau-form-field label="Startdatum" [validation]="form().validation.startDate">
            <wr-date-picker formControlName="startDate"/>
          </hau-form-field>

          <div class="field-with-info">
            <hau-form-field label="Dauer (Tage)" [validation]="form().validation.durationDays">
              <input nbInput type="number" fullWidth formControlName="durationDays" [valueAsNumber]="true"/>
            </hau-form-field>
            <span class="info-text">Nächster Termin: {{ nextDate | date: 'dd.MM.yyyy' }}</span>
          </div>

          <div class="field-with-info">
            <hau-form-field label="Erinnerung (Tage)" [validation]="form().validation.reminderDurationDays">
              <nb-icon hauSuffix icon="info-outline" pack="eva"
                       nbTooltip="Erinnerung wird per Email und per Notification vor der nächsten Wartung versendet">
              </nb-icon>
              <input nbInput type="number" fullWidth formControlName="reminderDurationDays" [valueAsNumber]="true"/>
            </hau-form-field>
            <span class="info-text">Erinnerung: {{ reminderDate | date: 'dd.MM.yyyy' }}</span>
          </div>

          <div class="fristen-section">
            <strong>Fristen:</strong>
            <span class="section-description">Wie viele Tage vor oder nach dem Termin ist eine Durchführung noch zulässig.</span>
          </div>

          <div class="field-with-info">
            <hau-form-field label="Tage vor Termin" [validation]="form().validation.earlyToleranceDays">
              <input nbInput type="number" fullWidth formControlName="earlyToleranceDays" [valueAsNumber]="true"/>
            </hau-form-field>
            @if (earlyToleranceDate) {
              <span class="info-text">{{ earlyToleranceDate | date: 'dd.MM.yyyy' }}</span>
            }
          </div>

          <div class="field-with-info">
            <hau-form-field label="Tage nach Termin" [validation]="form().validation.lateToleranceDays">
              <input nbInput type="number" fullWidth formControlName="lateToleranceDays" [valueAsNumber]="true"/>
            </hau-form-field>
            @if (form().getRawValue().lateToleranceDays === 0) {
              <span class="info-text">Keine Toleranz</span>
            } @else if (lateToleranceDate) {
              <span class="info-text">{{ lateToleranceDate | date: 'dd.MM.yyyy' }}</span>
            }
          </div>

          <div class="full-width">
            <nb-checkbox formControlName="imagesMandatory">
              Dienstleister dazu verpflichten vor dem Abschließen einer Wartung/Inspektion mind. ein Bild hochzuladen.
            </nb-checkbox>
          </div>
        </div>
      </div>
      <div class="footer">
        <div>
          @if (showCancelButton()) {
            <button nbButton size="small" (click)="cancelEditing()" fullWidth>Abbrechen</button>
          }
        </div>
        <div>
          <button nbButton status="primary" size="small" (click)="save()" class="save" fullWidth>Speichern</button>
        </div>
      </div>
    </div>
  } @else {
    @if (maintenanceTimer(); as timer) {
      <div class="timer-container">
        <div class="card-body">
          @if (showEquipmentLink()) {
            <div class="equipment-header"
                 role="button"
                 tabindex="0"
                 nbTooltip="TGA öffnen"
                 (click)="goToBuildingEquipment()"
                 (keydown.enter)="goToBuildingEquipment()">
              <div class="equipment-name">{{ equipmentName() }}</div>
              @if (sectionText()) {
                <div class="equipment-section">{{ sectionText() }}</div>
              }
              <nb-icon icon="external-link-outline" pack="eva" class="external-link-icon"></nb-icon>
            </div>
          }
          <div class="duration-days">
            {{ daysLeft() }} {{ daysLeft() | pluralize: 'Tag': 'Tage' }}
          </div>
          <div class="type">{{ timer.type | maintenanceTimerType }}</div>
          <div>
            <div class="label-and-text">
              <span class="label">Dauer</span>
              <span>{{ timer.durationDays }} {{ timer.durationDays | pluralize: 'Tag': 'Tage' }}</span>
            </div>
            <div class="label-and-text">
              <span class="label">Nächste {{ timer.type | maintenanceTimerType }}</span>
              <span>{{ timer.nextDate | date: 'dd.MM.yyyy' }}</span>
            </div>
            <div class="label-and-text">
              <span class="label">
                Frühester Kontrolltermin
                <nb-icon icon="info-outline" pack="eva"
                         nbTooltip="Wie viele Tage VOR dem geplanten Termin eine Wartung noch als pünktlich gilt">
                </nb-icon>
              </span>
              @if (timer.earlyToleranceDays > 0) {
                <span>
                  {{ timer.earlyToleranceDays }}
                  {{ timer.earlyToleranceDays | pluralize: 'Tag': 'Tage' }}
                  davor
                </span>
              } @else {
                <span>Keinen Tag Toleranz</span>
              }
            </div>
            <div class="label-and-text">
              <span class="label">
                Spätester Kontrolltermin
                <nb-icon icon="info-outline" pack="eva"
                         nbTooltip="Wie viele Tage NACH dem geplanten Termin eine Wartung noch als pünktlich gilt">
                </nb-icon>
              </span>
              @if (timer.lateToleranceDays > 0) {
                <span>
                  {{ timer.lateToleranceDays }}
                  {{ timer.lateToleranceDays | pluralize: 'Tag': 'Tage' }}
                  danach
                </span>
              } @else {
                <span>Keinen Tag Toleranz</span>
              }
            </div>
            <div class="label-and-text">
              <span class="label">Erinnerung</span>
              <span>{{ timer.reminderDate | date: 'dd.MM.yyyy' }}</span>
            </div>
            <div class="label-and-text">
              <span class="label">Wiederholungen</span>
              <span>{{ timer.iterations }}</span>
            </div>
            <div class="label-and-text">
              <span class="label">Letzte Verspätung</span>
              @if (timer.overdueDays !== null && timer.overdueDays !== undefined) {
                <span>
                  {{ timer.overdueDays }}
                  {{ timer.overdueDays | pluralize: 'Tag':'Tage' }}
                </span>
              } @else {
                <span>Wurde noch nie gewartet</span>
              }
            </div>

            <div class="label-and-text">
              <span class="label">Erstellt von</span>
              <span>{{ timer.creatorTenant.name }}</span>
            </div>
            <div class="label-and-text">
              <span class="label">Firma</span>
              <span>{{ timer.lastModifiedBy?.tenant?.name ?? timer.creatorTenant.name }}</span>
            </div>
            <div class="label-and-text">
              <span class="label">Benutzer</span>
              <span>{{ timer.lastModifiedBy?.fullName ?? timer.lastModifiedByName }}</span>
            </div>
            <div class="label-and-text">
              <span class="label">Gewartet von</span>
              @if (timer.lastFinisherName) {
                <span>{{ timer.lastFinisherName }}</span>
              } @else {
                <span>Nie gewartet</span>
              }
            </div>
          </div>
        </div>
        @if (canEditTimer() || canFinishTimer()) {
          <div class="footer">
            @if (canFinishTimer()) {
              <button nbButton size="medium"
                      status="basic"
                      nbTooltip="Wartung abschließen"
                      data-cy="maintenance-timer-finish"
                      (click)="finishMaintenanceTimer()"
                      [disabled]="!timer.isAllowedToFinish">
                <nb-icon icon="checkmark-circle-2-outline" pack="eva"></nb-icon>
              </button>
            }
            @if (canEditTimer()) {
              <button nbButton size="medium" status="basic" nbTooltip="Bearbeiten" (click)="startEdit()">
                <nb-icon icon="edit-outline" pack="eva"></nb-icon>
              </button>
            }
            @if (canShowHistory()) {
              <button nbButton size="medium" status="basic" (click)="showMaintenanceHistory()"
                      nbTooltip="Wartungshistorie">
                <nb-icon icon="calendar-outline" pack="eva"></nb-icon>
              </button>
            }
            @if (canEditTimer()) {
              <button nbButton size="medium" status="basic" nbTooltip="Löschen" (click)="deleteEntity()">
                <nb-icon icon="trash-2-outline" pack="eva"></nb-icon>
              </button>
            }
          </div>
        }
      </div>
    }
  }
</div>
